module.exports = __webpack_public_path__ + "img/Instagram.f34aa936.svg";